"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagDelegatedDomainStatus = exports.TagHostType = exports.PackType = exports.StorageMethods = exports.UserRoles = exports.BYOIDTypes = exports.CookielessTypes = exports.TagCompilationErrorWhere = exports.TagCompilationErrorType = exports.TagVersion = exports.TagCompilationStatus = void 0;
var TagCompilationStatus;
(function (TagCompilationStatus) {
    TagCompilationStatus["Empty"] = "empty";
    TagCompilationStatus["Compiled"] = "compiled";
    TagCompilationStatus["Timeout"] = "timeout";
    TagCompilationStatus["Error"] = "error";
    TagCompilationStatus["Pending"] = "pending";
    TagCompilationStatus["Deployed"] = "deployed";
})(TagCompilationStatus = exports.TagCompilationStatus || (exports.TagCompilationStatus = {}));
var TagVersion;
(function (TagVersion) {
    TagVersion["Latest"] = "latest";
    TagVersion["Next"] = "next";
    TagVersion["Unstable"] = "unstable";
    TagVersion["Deprecated"] = "deprecated";
})(TagVersion = exports.TagVersion || (exports.TagVersion = {}));
var TagCompilationErrorType;
(function (TagCompilationErrorType) {
    TagCompilationErrorType["Internal"] = "internal";
    TagCompilationErrorType["Js"] = "js";
    TagCompilationErrorType["More"] = "more";
})(TagCompilationErrorType = exports.TagCompilationErrorType || (exports.TagCompilationErrorType = {}));
var TagCompilationErrorWhere;
(function (TagCompilationErrorWhere) {
    TagCompilationErrorWhere["Consent"] = "consent";
    TagCompilationErrorWhere["Account"] = "account";
    TagCompilationErrorWhere["Fragment"] = "fragment";
    TagCompilationErrorWhere["Scope"] = "scope";
    TagCompilationErrorWhere["Trigger"] = "trigger";
    TagCompilationErrorWhere["Campaign"] = "campaign";
    TagCompilationErrorWhere["Variation"] = "variation";
    TagCompilationErrorWhere["Analytics"] = "analytics";
})(TagCompilationErrorWhere = exports.TagCompilationErrorWhere || (exports.TagCompilationErrorWhere = {}));
var CookielessTypes;
(function (CookielessTypes) {
    CookielessTypes["HTTPOnly"] = "httponly";
    CookielessTypes["CNAME"] = "cname";
    CookielessTypes["BYOID"] = "byoid";
})(CookielessTypes = exports.CookielessTypes || (exports.CookielessTypes = {}));
/** ******************
 * BYOID
 ******************* */
var BYOIDTypes;
(function (BYOIDTypes) {
    BYOIDTypes["Cookie"] = "cookie";
    BYOIDTypes["LocalStorage"] = "local_storage";
    BYOIDTypes["JSVariable"] = "js_variable";
})(BYOIDTypes = exports.BYOIDTypes || (exports.BYOIDTypes = {}));
var UserRoles;
(function (UserRoles) {
    UserRoles["viewer"] = "viewer";
    UserRoles["creator"] = "creator";
    UserRoles["user"] = "user";
    UserRoles["admin"] = "admin";
    UserRoles["superAdmin"] = "super_admin";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
var StorageMethods;
(function (StorageMethods) {
    StorageMethods["Cookies"] = "cookies";
    StorageMethods["LocalStorage"] = "local";
})(StorageMethods = exports.StorageMethods || (exports.StorageMethods = {}));
var PackType;
(function (PackType) {
    PackType["Premium"] = "premium";
    PackType["Inactive"] = "inactive";
})(PackType = exports.PackType || (exports.PackType = {}));
var TagHostType;
(function (TagHostType) {
    TagHostType["MAIN"] = "main";
    TagHostType["DELEGATED"] = "delegated";
})(TagHostType = exports.TagHostType || (exports.TagHostType = {}));
var TagDelegatedDomainStatus;
(function (TagDelegatedDomainStatus) {
    TagDelegatedDomainStatus[TagDelegatedDomainStatus["IDLE"] = 0] = "IDLE";
    TagDelegatedDomainStatus[TagDelegatedDomainStatus["PENDING"] = 1] = "PENDING";
    TagDelegatedDomainStatus[TagDelegatedDomainStatus["DONE"] = 2] = "DONE";
    TagDelegatedDomainStatus[TagDelegatedDomainStatus["ERROR"] = 3] = "ERROR";
})(TagDelegatedDomainStatus = exports.TagDelegatedDomainStatus || (exports.TagDelegatedDomainStatus = {}));
//# sourceMappingURL=types.js.map